<template>
  <div class="bg-white rounded-lg shadow p-4 space-y-2">
    <div class="flex items-center justify-between gap-2">
      <div class="text-base font-semibold text-dark-primary">{{ company.company_name }}</div>
      <!-- Saving needs a connection to log it on the server; unsaving works offline -->
      <button
        class="-m-1 p-1 shrink-0 text-accent-primary disabled:text-gray-300"
        :disabled="disabled || busy || (!saved && !isOnline)"
        @click.stop="emit('toggle-save')"
      >
        <!-- iOS-style spinner: 8 dashes fading around a circle, turning one dash at a time -->
        <svg v-if="busy" class="h-5 w-5 animate-spin text-accent-primary" style="animation-timing-function: steps(8)" viewBox="0 0 24 24">
          <line
            v-for="dash in 8"
            :key="dash"
            x1="12" y1="2.5" x2="12" y2="7"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
            :opacity="dash / 8"
            :transform="`rotate(${dash * 45} 12 12)`"
          />
        </svg>
        <BookmarkIcon v-else-if="saved" class="h-5 w-5" />
        <BookmarkOutlineIcon v-else class="h-5 w-5" />
      </button>
    </div>
    <div class="grid grid-cols-3 gap-x-2 gap-y-1 text-sm">
      <div class="text-gray-500">Campaign</div>
      <div class="col-span-2">{{ company.campaign ? company.campaign.campaign_name : '--' }}</div>

      <div class="text-gray-500">Contact</div>
      <div class="col-span-2">{{ firstContact }}</div>

      <div class="text-gray-500">Status</div>
      <div class="col-span-2">{{ currentStatus }}</div>

      <div class="text-gray-500">Next action</div>
      <div class="col-span-2">{{ nextAction }}</div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';
import { useOnline } from '@vueuse/core';
import { currentStatusText, nextActionText } from '@/components/mobile/company/companyDisplay';
import { contactName } from '@/components/mobile/contact/contactDisplay';
import { BookmarkIcon } from '@heroicons/vue/20/solid';
import { BookmarkIcon as BookmarkOutlineIcon } from '@heroicons/vue/24/outline';

const props = defineProps({
  company: Object,
  saved: Boolean,
  busy: Boolean,
  disabled: Boolean
})

const emit = defineEmits(['toggle-save'])

const isOnline = useOnline()

// Primary contact if there is one, otherwise the first contact
const firstContact = computed(() => {
  const contacts = props.company.contacts || []
  const relationship = contacts.find(c => c.is_primary_contact) || contacts[0]
  if (!relationship) {
    return '--'
  }
  const name = contactName(relationship)
  return relationship.title ? `${name}, ${relationship.title}` : name || '--'
})

const currentStatus = computed(() => currentStatusText(props.company))

const nextAction = computed(() => nextActionText(props.company))
</script>
